import React, {
	useState,
	useEffect,
	useLayoutEffect,
	useCallback,
} from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import NoContents from './NoContents';
import detailItem from '../../assets/goDetail.png';

import Arrow from '../../assets/icons/arrow.svg';
import FilterCategoryButton from '../../component/FilterCategoryButton';
import { _getOnChainCollectionItems } from '../../function/functions';
import { useRecoilState } from 'recoil';
import {
	BoxDetailModalOpen,
	PFPUnboxingData,
} from '../../recoil-states/user-state/user-state';
import styled from 'styled-components';
import MembershipWalletModal from '../../component/detailModal/MemberShipWalletModal';
import MypageNftData from '../../component/detailModal/NftWalletModal';
import ShillaDetailModal from '../../component/detailModal/ShillaWalletModal';
import ShillaPackage from '../../component/detailModal/ShillaPackage';
import whiteLogo from '../../assets/mobile_assets/icons/m_kctLogo.svg';
import colorLogo from '../../assets/stakelogo.svg';
import { isMobile } from 'react-device-detect';
import ProgressiveImage from 'react-progressive-graceful-image';
import { AnimatePresence } from 'framer-motion';

export default function KonnectWallet({
	data,
	textData,
	language,
	categoryList,
	selectedCategoryMain,
	setSelectedCategoryMain,
	selectedCategorySub,
	setSelectedCategorySub,
	handleUnboxing,
	handleTransfer,
	setBoxDetailModal,
	setShillaData,
	currentAddress,
}) {
	const [boxDetailModalOpen, setBoxDetailModalOpen] =
		useRecoilState(BoxDetailModalOpen);
	const [unboxingData, setUnboxingData] = useRecoilState(PFPUnboxingData);
	const [hoverItem, setHoverItem] = useState(null);
	const [openDetailModal, setOpenDetailModal] = useState(-1);
	const [openPfpModal, setOpenPfpModal] = useState(-1);
	const [openShillaUnboxModal, setOpenShillaUnboxModal] = useState(false);
	const [isMobileMode, setIsMobileMode] = useState(false);
	const [viewData, setViewData] = useState([]);

	useEffect(() => {
		// if (categoryList.length > 3) setIsMobileMode(false);
		if (categoryList.length > 4) setIsMobileMode(false);
		else setIsMobileMode(true);
	}, [categoryList]);

	useEffect(() => {
		if (Object.keys(data).length > 0) {
			if (
				isMobileMode &&
				selectedCategoryMain === 0 &&
				1 in data &&
				2 in data &&
				3 in data
			) {
			} else setViewData(data[selectedCategorySub]);
		}
	}, [isMobileMode, data, selectedCategoryMain, selectedCategorySub]);

	const modalClose = useCallback(() => {
		setOpenDetailModal(null);
	});

	const _mappingItemInList = (item, index) => {
		let imgUrl;
		let modalimgUrl;
		let listimgUrl;
		let category;
		let grade;
		let nft_no;
		let onClick;
		let buttonText;
		let dumanName;
		let DetailsBtnOnClick;
		const duman_name = nft_no => {
			if (nft_no >= 1 && nft_no <= 50) {
				return (dumanName =
					textData.duman_name.tori.toLocaleUpperCase());
			} else if (nft_no >= 51 && nft_no <= 150) {
				return (dumanName =
					textData.duman_name.collin.toLocaleUpperCase());
			} else if (nft_no >= 151 && nft_no <= 350) {
				return (dumanName =
					textData.duman_name.dove.toLocaleUpperCase());
			} else if (nft_no >= 351 && nft_no <= 750) {
				return (dumanName = textData.duman_name.km.toLocaleUpperCase());
			} else if (nft_no >= 751 && nft_no <= 1500) {
				return (dumanName =
					textData.duman_name.andre.toLocaleUpperCase());
			}
		};
		if (item.type === 'product') {
			// 신라 이슈
			modalimgUrl = item.data.minting_active
				? `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${item.data.ipfs_image_local_url}`
				: // 신라 or PFP 이미지 경로 이슈
				item.data.product_index.category == 'Utility'
					? `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${item.data.ipfs_image_local_url}`
					: item.data.product_index.category == 'Membership'
						? `${process.env.REACT_APP_BACKEND_API}/assets/${item.data.product_index.image_item}`
						: `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${item.data.ipfs_image_local_url}`;
			listimgUrl =
				item.data.minting_active &&
					item.data.kct_nft_index?.title === 'KCT_NFT_PFP_DUMAN'
					? `${process.env.REACT_APP_BACKEND_API}/assets/${item.data.product_index?.image_raw}`
					: // 신라 or PFP 이미지 경로 이슈
					item.data.product_index.category == 'Utility'
						? `${process.env.REACT_APP_BACKEND_API}/assets/${item.data.product_index?.image_raw}`
						: item.data.product_index.category == 'Membership'
							? `${process.env.REACT_APP_BACKEND_API}/assets/${item.data.product_index?.image_raw}`
							: `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${item.data.ipfs_image_local_url}`;
			category = item.data.product_index.category;
			grade = item.data.product_index.nft_grade;
			nft_no = item.data.nft_no;
			onClick = handleTransfer;
			// DetailsBtnOnClick = setShillaModal;
			DetailsBtnOnClick = setBoxDetailModal;
			buttonText = textData.myPage['Transfer to On-Chain'];
		} else if (item.type === 'box') {
			imgUrl = `${process.env.REACT_APP_BACKEND_API}/assets/${item.data.kct_nft_index.image}`;
			category = item.data.kct_nft_index.title; //임의
			grade = 'Box'; //임의
			// nft_no = 0; //임의
			onClick = handleUnboxing;
			buttonText = textData.myPage['Unbox'];
		} else {
			return null;
		}

		return (
			<>
				{openShillaUnboxModal ? (
					<ShillaPackage
						setOpenShillaUnboxModal={setOpenShillaUnboxModal}
						view={true}
						onClick={onClick}
						item={item}
					/>
				) : null}
				<Col
					lg='4'
					md='12'
					xl='4'
					key={nft_no}
					style={{
						position: 'relative',
						maxWidth:
							(isMobile || window.innerWidth <= 1200) &&
								item.data.product_index?.category === 'Membership'
								? '50%'
								: (isMobile || window.innerWidth <= 1200) &&
									item.data.product_index?.category === 'PFP'
									? '95%'
									: (isMobile || window.innerWidth <= 1200) &&
										item.data.product_index?.category ===
										'Utility'
										? '50%'
										: isMobile || window.innerWidth <= 1200
											? '95%'
											: '32rem',
					}}
					className='myPage_card_wrap'>
					<div
						className='myPage_card'
						style={{
							background:
								(isMobile || window.innerWidth <= 1200) &&
									item.data.product_index?.category ===
									'Membership'
									? 'transparent'
									: (isMobile || window.innerWidth <= 1200) &&
										item.data.product_index?.category ===
										'Utility'
										? 'transparent'
										: '',
						}}>
						<div
							// className={"myPage_card_img"}
							className={
								item?.isOnChain
									? 'myPage_card_img active'
									: 'myPage_card_img'
							}
							style={{
								position:
									item.data.product_index?.category === 'PFP'
										? 'relative'
										: null,
							}}>
							{item.data.kct_nft_index?.title ===
								'KCT_NFT_PFP_DUMAN' ? (
								<HoverBox
									onMouseOver={() => {
										return !isMobile
											? setHoverItem(index)
											: null;
									}}
									onMouseLeave={() => setHoverItem(null)}
									style={{
										height: '100%',
										opacity:
											hoverItem === index && !isMobile
												? '1'
												: '0',
										borderRadius: "10px 10px 0 0"
									}}
									onClick={() => {
										setUnboxingData(item.data);
										setBoxDetailModalOpen(true);
									}}>
									<img
										src={detailItem}
										style={{ width: '30%', height: '30%' }}
									/>
								</HoverBox>
							) : null}
							{item.data.kct_nft_index?.title ===
								'NFT_Utility' ? (
								<HoverBox
									onMouseOver={() => {
										return !isMobile
											? setHoverItem(index)
											: null;
									}}
									onMouseLeave={() => setHoverItem(null)}
									style={{
										height: '100%',
										opacity:
											hoverItem === index && !isMobile
												? '1'
												: '0',
										borderRadius: "10px 10px 0 0"
									}}
									onClick={() => {
										setOpenShillaUnboxModal(true);
									}}>
									<img
										src={detailItem}
										style={{ width: '30%', heigit: '30%' }}
									/>
								</HoverBox>
							) : null}
							{/* lazyLoading */}
							<ProgressiveImage src={listimgUrl || imgUrl}>
								{(src, loading) => {
									return !loading ? (
										<img
											src={src}
											style={{
												width: '100%',
												background: imgUrl
													? 'var(--button-border-color)'
													: null,
											}}
										/>
									) : (
										<div className='skeleton'>
											{/* <h1>로딩</h1> */}
											{/* <Lottie animationData={require('../../assets/lod.json')} play loop style={{ borderRadius: "10px 10px 0 0" }} /> */}
										</div>
									);
								}}
							</ProgressiveImage>
						</div>
						<div className='myPage_card_text'>
							<div
								className='myPage_card_name'
								style={{
									width: '100%',
									justifyContent:
										item.type === 'box'
											? 'center'
											: 'space-between',
								}}>
								{item.type === 'box' &&
									item.data.type === 'pfp_duman' ? (
									<>
										<h3>
											{' '}
											Konnect World &nbsp;DUMAN Package{' '}
											{isMobile ||
												window.innerWidth <= 1200 ? (
												<img
													className='myPage_card_state'
													src={
														item.data
															.wallet_address ===
															currentAddress
															? colorLogo
															: whiteLogo
													}
												/>
											) : null}
										</h3>
									</>
								) : item.type === 'box' &&
									item.data.type === 'utility' ? (
									<>
										<h3>
											{' '}
											Konnect World &nbsp;Shilla Package{' '}
											{isMobile ||
												window.innerWidth <= 1200 ? (
												<img
													className='myPage_card_state'
													src={
														item.data
															.wallet_address ===
															currentAddress
															? colorLogo
															: whiteLogo
													}
												/>
											) : null}
										</h3>
									</>
								) : item.type === 'product' &&
									item.data.product_index?.category ===
									'PFP' ? (
									<>
										{openPfpModal === index &&
											openPfpModal !== -1 &&
											item.data.product_index?.category ===
											'PFP' ? (
											<MypageNftData
												onChain={() =>
													onClick(item.data)
												}
												setOpenPfplModal={
													setOpenPfpModal
												}
												index={index}
												openDetailModal={
													openDetailModal
												}
												item={item}
												imgUrl={modalimgUrl}
											/>
										) : null}
										<div
											className='cardBox_text'
											style={{
												display: 'flex',
												justifyContent: 'flex-start',
												cursor: 'pointer',
												alignItems:
													isMobile ||
														window.innerWidth <= 1200
														? 'center'
														: 'baseline',
												width: '100%',
											}}>
											<h3>
												{textData.duman_category.duman}
											</h3>
											<h3>&nbsp;:&nbsp;</h3>
											<h3>{duman_name(nft_no)}</h3>
										</div>
										<div className='cardBox_text_noBox'>
											<img
												className='myPage_card_state'
												src={
													item.data.wallet_address ===
														currentAddress
														? colorLogo
														: whiteLogo
												}
											/>
											<h3>&nbsp;&nbsp;&nbsp;#{nft_no}</h3>
										</div>
										<HoverBox
											style={{
												opacity:
													hoverItem === index &&
														!isMobile
														? '1'
														: '0',
												height: '100%',
											}}
											onMouseOver={() => {
												return !isMobile
													? setHoverItem(index)
													: null;
											}}
											onMouseLeave={() =>
												setHoverItem(null)
											}
											onClick={() =>
												setOpenPfpModal(index)
											}>
											<img
												src={detailItem}
												style={{ width: '30%' }}
											/>
										</HoverBox>
									</>
								) : item.type === 'product' &&
									item.data.product_index?.category ===
									'Membership' ? (
									<>
										<AnimatePresence>
											{openDetailModal === index &&
												openDetailModal !== null && (
													<MembershipWalletModal
														setOpenDetailModal={
															setOpenDetailModal
														}
														index={index}
														openDetailModal={
															openDetailModal
														}
														item={item}
														imgUrl={modalimgUrl}
													/>
												)}
										</AnimatePresence>
										<div
											style={{
												cursor: 'pointer',
												display: 'flex',
												flexDirection: 'column',
												alignItems: isMobileMode
													? 'center'
													: 'flex-start',
												width: '100%',
											}}>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent:
														'space-around',
													width: '100%',
												}}>
												{isMobile ||
													window.innerWidth <= 1200 ? (
													<h3
														style={{
															fontWeight: '400',
															color: '#0E0D0D',
														}}>
														{item.data.product_index.product_name
															.replace(
																'Konnect',
																''
															)
															.replace(
																'MEMBERSHIP',
																''
															)
															.replace('VIP', '')}
														<img
															className='myPage_card_state'
															src={
																item.data
																	.wallet_address ===
																	currentAddress
																	? colorLogo
																	: whiteLogo
															}
														/>
													</h3>
												) : (
													<h3
														style={{
															fontSize: '15px',
															fontWeight: '400',
														}}>
														{
															item.data
																.product_index
																.product_name
														}
													</h3>
												)}
											</div>
											<div>
												{/* <h3># {item.data.nft_no}</h3> */}
											</div>
											<HoverBox
												style={{
													opacity:
														hoverItem === index &&
															!isMobile
															? '1'
															: '0',
													height: '100%',
												}}
												onMouseOver={() => {
													return !isMobile
														? setHoverItem(index)
														: null;
												}}
												onMouseLeave={() =>
													setHoverItem(null)
												}
												onClick={() => {
													setOpenDetailModal(index);
												}}>
												<img
													src={detailItem}
													style={{ width: '30%' }}
												/>
											</HoverBox>
										</div>
									</>
								) : (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											width: '100%',
										}}>
										{openDetailModal === index ? (
											<ShillaDetailModal
												item={item}
												setOpenDetailModal={
													setOpenDetailModal
												}
												imgUrl={modalimgUrl}
												onChain={() =>
													onClick(item.data)
												}
											/>
										) : null}
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-around',
												width: '100%',
											}}>
											{isMobile ||
												window.innerWidth <= 1200 ? (
												<h3
													style={{
														fontSize: '15px',
														fontWeight: '400',
														color: '#0E0D0D',
													}}>
													SHILLA
													<img
														className='myPage_card_state'
														src={
															item.data
																.wallet_address ===
																currentAddress
																? colorLogo
																: whiteLogo
														}
													/>
												</h3>
											) : (
												<h3>
													Konnect SHILLA VIP
													MEMBERSHIP
												</h3>
											)}
										</div>
										<div>
											{isMobile ||
												window.innerWidth <= 1200 ? null : (
												<h3># {item.data.nft_no}</h3>
											)}
										</div>
										<HoverBox
											style={{
												opacity:
													hoverItem === index &&
														!isMobile
														? '1'
														: '0',
												height: '100%',
											}}
											onMouseOver={() => {
												return !isMobile
													? setHoverItem(index)
													: null;
											}}
											onMouseLeave={() =>
												setHoverItem(null)
											}
											onClick={() => {
												setOpenDetailModal(index);
											}}>
											<img
												src={detailItem}
												style={{ width: '30%' }}
											/>
										</HoverBox>
									</div>
								)}
							</div>
							{/* nft 넘버는 미표시 */}
							{/* <h3>{item.type === 'product' && `#${nft_no}`}</h3> */}
						</div>
						{item.data.product_index?.category !== 'Membership' ? (
							<div className='myPage_myWallet_button'>
								{item.type === 'product' &&
									item.data.product_index?.category ===
									'Utility' ? (
									<button
										onClick={() => {
											setShillaData(item.data);
											setOpenDetailModal(index);
										}}>
										{textData.mypage2['Details']}
									</button>
								) : null}
								{item.isOnChain ? null : (
									<button
										onClick={() => {
											onClick(item.data);
										}}>
										{buttonText}
									</button>
								)}
							</div>
						) : null}
					</div>
				</Col>
			</>
		);
	};

	return (
		<>
			<Row className='collection_content'>
				<Col lg='3' md='3' className='category'>
					{categoryList.length > 0 &&
						categoryList.map((mainCategory, mainCategoryIndex) => {
							const subCategories = () =>
								categoryList[
									mainCategoryIndex
								].subCategories.map(
									(subCategory, subCategoryIndex) => {
										return (
											<FilterCategoryButton
												key={subCategoryIndex}
												text={
													subCategory.name[language]
												}
												subText={''}
												isSubTextBold
												isSelected={
													selectedCategoryMain ===
													mainCategoryIndex &&
													selectedCategorySub ===
													subCategoryIndex
												}
												onClick={() => {
													setSelectedCategorySub(
														subCategoryIndex
													);
												}}
											/>
										);
									}
								);
							return (
								<>
									{isMobileMode ? (
										<div
											key={mainCategoryIndex}
											open={
												selectedCategoryMain ===
												mainCategoryIndex
											}
											onClick={e => {
												e.preventDefault();
												setSelectedCategoryMain(
													mainCategoryIndex
												);
												setSelectedCategorySub(0);
											}}
											className={
												selectedCategoryMain ===
													mainCategoryIndex
													? 'active'
													: null
											}>
											<p>{mainCategory.name[language]}</p>
										</div>
									) : (
										<details
											key={mainCategoryIndex}
											open={
												selectedCategoryMain ===
												mainCategoryIndex
											}
											onClick={e => {
												e.preventDefault();
												setSelectedCategoryMain(
													mainCategoryIndex
												);
												setSelectedCategorySub(0);
											}}>
											<summary>
												<p>
													{
														mainCategory.name[
														language
														]
													}
												</p>
												<img src={Arrow} />
											</summary>
											<div
												style={{
													padding: '15px 25px',
													paddingLeft: '35px',
													paddingTop: '25px',
													borderTop:
														'1px solid var(--border-color)',
												}}>
												{subCategories()}
											</div>
										</details>
									)}
								</>
							);
						})}
				</Col>
				<Col lg='9' md='9' className='card_list'>
					{categoryList.length > 0 && (
						<>
							{isMobile || window.innerWidth <= 1200 ? null : (
								<Row className='card_list_title'>
									<Col lg='12' md='12'>
										<div className='title'>
											<h2>
												{
													categoryList[
														selectedCategoryMain
													]?.name[language]
												}
											</h2>
										</div>
									</Col>
								</Row>
							)}
							{isMobile || window.innerWidth <= 1200 ? null : (
								<Row className='card_list_filterType'>
									<Col lg='12' md='12'>
										<div className='type'>
											<h3>
												{
													categoryList[
														selectedCategoryMain
													]?.subCategories[
														selectedCategorySub
													].name[language]
												}
											</h3>
										</div>
									</Col>
								</Row>
							)}
						</>
					)}
					<Row className='card_list_filter'>
						{isMobileMode && selectedCategoryMain === 1 ? (
							<p className='mobile_SubCategory_SubTitle'>
								<b>Benefit Card</b>
							</p>
						) : isMobileMode && selectedCategoryMain === 2 ? (
							<p className='mobile_SubCategory_SubTitle'>
								<b style={{ margin: 0 }}>NFT_</b>DUMAN PFP
							</p>
						) : isMobileMode && selectedCategoryMain === 3 ? (
							<p className='mobile_SubCategory_SubTitle'>
								<b style={{ margin: 0 }}>Package</b>
							</p>
						) : null}
					</Row>

					{isMobileMode && selectedCategoryMain === 0 ? (
						<Row className='myPage_card_list_wrap'>
							{Object.keys(data)?.length > 0 &&
								data[1]?.length > 0 ? (
								<>
									<p className='mobile_SubTitle'>
										<b>Benefit Card</b>
									</p>
									{data[1].map(_mappingItemInList)}
								</>
							) : null}
							{Object.keys(data)?.length > 0 &&
								data[2]?.length > 0 ? (
								<>
									<p className='mobile_SubTitle'>
										<b style={{ margin: 0 }}>NFT_</b>DUMAN
										PFP
									</p>
									{data[2].map(_mappingItemInList)}
								</>
							) : null}
							{Object.keys(data)?.length > 0 &&
								data[3]?.length > 0 ? (
								<>
									<p className='mobile_SubTitle'>
										<b>Package</b>
									</p>
									{data[3].map(_mappingItemInList)}
								</>
							) : null}
							{Object.keys(data)?.length > 0 &&
								data[1]?.length <= 0 &&
								data[2]?.length <= 0 &&
								data[3]?.length <= 0 ? (
								<NoContents textData={textData} />
							) : null}
						</Row>
					) : (
						<Row className='myPage_card_list_wrap'>
							{Object.keys(data)?.length > 0 &&
								viewData.length > 0 ? (
								viewData.map(_mappingItemInList)
							) : (
								<NoContents textData={textData} />
							)}
						</Row>
					)}
				</Col>
			</Row>
		</>
	);
}

const HoverBox = styled.div`
	width: ${isMobile || window.innerWidth <= 1200
		? 'calc(100% - 0.25rem)'
		: '100%'};
	height: 100%;
	position: absolute;
	top: 0%;
	left: 0%;
	cursor: pointer;
	border-radius: 1rem;
	background-color: rgba(0, 0, 0, 0.7);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.3s ease-in-out;
	margin-left: ${isMobile || window.innerWidth <= 1200 ? '0.1225rem' : '0'};
	/* opacity: ${isMobile || window.innerWidth <= 1200 ? '0' : '1'}; */
`;
